import Modal from "@/components/Modal.vue";
import Library from "@/components/Library.vue";
import modalBus from "@/bus/modal-bus";

export default {
  components: {
    Modal,
    Library,
  },
  data() {
    return {
      notify:null,
      modal: {
        component: "",
        data: {},
      },
    };
  },
  created() {
    modalBus.$on("change", (content: { component: string; data: object }) => {
      // @ts-ignore
      this.modal.data = content.data;
      // @ts-ignore
      this.modal.component = content.component;
    });
    modalBus.$on("clear", () => {
      // @ts-ignore
      this.modal.data = {};
      // @ts-ignore
      this.modal.component = "";
    });
  },
};
